import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { intlMessage } from 'constants/propTypes';
import { Card, CardTitle } from 'components/Card';
import LoadingDots from 'components/LoadingDots';
import Message from 'components/Message';
import Tags from './Tags';

const TagSection = forwardRef(({ className, title, explanation, footer, loading, ...restProps }, ref) => (
  <Card ref={ref} className={classNames('edit-section', className)}>
    <Message as={CardTitle} message={title} />
    <Message as="p" className="text--light" message={explanation} />
    {loading ? <LoadingDots /> : <Tags {...restProps} />}
    {footer && <Message as="p" className="text--light" message={footer} />}
  </Card>
));

TagSection.propTypes = {
  className: PropTypes.string,
  title: intlMessage,
  explanation: intlMessage,
  footer: intlMessage,
  loading: PropTypes.bool,
};

TagSection.displayName = 'TagSection';

export default TagSection;
